(function () {
  const money = (cents) => {
    try {
      return 'Rs. ' + (Number(cents) / 100).toLocaleString('en-PK', { maximumFractionDigits: 0 });
    } catch (e) {
      return 'Rs. ' + Math.round(Number(cents) / 100);
    }
  };

  const $ = (sel, root = document) => root.querySelector(sel);
  let cachedCart = null;
  let discountCleanupScheduled = false;
  let qtyRequestVersion = 0;
  let cartRefreshPromise = null;
  let pageSelection = null;

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }

  function setCachedCart(cart) {
    cachedCart = cart;
    return cart;
  }

  function prefetchCart() {
    if (cartRefreshPromise) return cartRefreshPromise;
    cartRefreshPromise = fetchCart()
      .then(setCachedCart)
      .then(function (cart) {
        updateCount(cart);
        return cart;
      })
      .catch(function () {})
      .finally(function () {
        cartRefreshPromise = null;
      });
    return cartRefreshPromise;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefetchCart, { once: true });
  } else {
    prefetchCart();
  }

  function refreshCartInBackground() {
    fetchCart()
      .then(function (cart) {
        setCachedCart(cart);
        updateCount(cart);
        const drawer = document.getElementById('ot-cart-drawer');
        if (drawer && drawer.classList.contains('cart-drawer--open')) {
          renderCart(cart, true);
        }
      })
      .catch(function () {});
  }

  function updateCount(cart) {
    const el = document.getElementById('cart-count') || document.querySelector('.cart-count');
    if (!el) return;
    const n = cart.item_count || 0;
    el.textContent = String(n);
    el.style.display = n > 0 ? 'flex' : 'none';
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function lineImage(item) {
    if (item.image) return String(item.image);
    const cfg = (window.OT_CART_CONFIG && window.OT_CART_CONFIG.images) || {};
    const variant = String(item.variant_title || '').toLowerCase();
    const handle = String(item.handle || item.product_handle || '').toLowerCase();
    const title = String(item.product_title || '').toLowerCase();

    if (handle.indexOf('couple') !== -1 || title.indexOf('couple') !== -1) return cfg.couple || '';
    if (variant.indexOf('women') !== -1 || variant.indexOf('balance') !== -1) return cfg.women || '';
    if (variant.indexOf('men') !== -1 || variant.indexOf('active') !== -1) return cfg.men || '';

    const raw =
      (item.featured_image && (item.featured_image.url || item.featured_image.src)) || item.image || '';
    if (!raw) return cfg.men || '';
    return String(raw).replace(/^\/\//, 'https://');
  }

  function prepaidCfg() {
    return (window.OT_CART_CONFIG && window.OT_CART_CONFIG.prepaid) || {};
  }

  function cartProductsTotal(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return sum + Number(item.original_line_price || item.final_line_price || item.line_price || 0);
    }, 0);
  }

  async function clearCartDiscountCode() {
    try {
      await fetch('/discount/CLEAR', { credentials: 'same-origin', redirect: 'manual' });
    } catch (e) {}
  }

  function cartHasCodeDiscount(cart) {
    const apps = cart.cart_level_discount_applications || [];
    if (!apps.length) return false;
    const code = String((prepaidCfg().discountCode || 'PREPAID90')).toUpperCase();
    return apps.some(function (a) {
      const t = String((a.title || '') + ' ' + (a.code || '')).toUpperCase();
      return t.indexOf(code) !== -1 || t.indexOf('PREPAID') !== -1 || t.indexOf('OFF ON DELIVERY') !== -1;
    });
  }

  function isPrepaidSelected(cart) {
    const attrs = (cart && cart.attributes) || {};
    return String(attrs.prepaid_free_delivery || '').toLowerCase() === 'yes';
  }

  function renderPrepaidBank() {
    const cfg = prepaidCfg();
    const bank = document.getElementById('ot-prepaid-bank');
    if (!bank) return;
    const title = cfg.accountTitle || '';
    const num = cfg.accountNumber || '';
    const amt = cfg.amountLabel || 'Rs. 90';
    bank.innerHTML =
      '<div><strong>JazzCash</strong> ' +
      escapeHtml(num) +
      (title ? ' · ' + escapeHtml(title) : '') +
      ' · pay <strong>' +
      escapeHtml(amt) +
      '</strong> → get <strong>extra Rs. 90 off</strong> at checkout</div>';

    const wa = document.getElementById('ot-prepaid-wa');
    if (wa) {
      const phone = String(cfg.whatsapp || '923019080669').replace(/\D/g, '');
      const msg =
        'Hi! I paid Rs. 90 advance for extra Rs. 90 off on Weight Loss Tea Pakistan.\n\n' +
        'Please confirm my order.\n' +
        'Payment proof attached.\n' +
        'Name: \nOrder # / Phone: ';
      wa.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(msg);
    }
  }

  function syncPrepaidUI(cart) {
    const cfg = prepaidCfg();
    const wrap = document.getElementById('ot-prepaid');
    if (!wrap || cfg.enabled === false) {
      if (wrap) wrap.hidden = true;
      return;
    }

    const check = document.getElementById('ot-prepaid-check');
    const panel = document.getElementById('ot-prepaid-panel');
    const note = document.getElementById('ot-cart-shipping-note');
    const checkoutBtn = document.getElementById('ot-cart-checkout-btn');
    wrap.hidden = false;

    const on = isPrepaidSelected(cart);
    if (check) check.checked = on;
    if (panel) {
      if (on) {
        panel.hidden = false;
        panel.removeAttribute('hidden');
      } else {
        panel.hidden = true;
        panel.setAttribute('hidden', '');
      }
    }
    renderPrepaidBank();

    if (note) note.textContent = on ? '✓ Extra Rs. 90 off after advance proof' : 'Open-parcel policy · COD';
    if (checkoutBtn) {
      checkoutBtn.href =
        on && cfg.discountCode
          ? '/discount/' + encodeURIComponent(cfg.discountCode) + '?redirect=/checkout'
          : '/checkout';
    }
  }

  function scheduleDiscountCleanup(cart) {
    if (!cartHasCodeDiscount(cart) || discountCleanupScheduled) return;
    discountCleanupScheduled = true;
    setTimeout(function () {
      clearCartDiscountCode()
        .then(fetchCart)
        .then(function (fresh) {
          setCachedCart(fresh);
          const drawer = document.getElementById('ot-cart-drawer');
          if (drawer && drawer.classList.contains('cart-drawer--open')) renderCart(fresh, true);
          else updateCount(fresh);
        })
        .catch(function () {})
        .finally(function () {
          discountCleanupScheduled = false;
        });
    }, 1200);
  }

  function optimisticQtyChange(cart, keyOrId, qty) {
    const items = (cart.items || []).map(function (item) {
      return Object.assign({}, item);
    });
    const idx = items.findIndex(function (item) {
      return item.key === keyOrId || String(item.id) === String(keyOrId);
    });
    if (idx === -1) return null;

    if (qty <= 0) {
      items.splice(idx, 1);
    } else {
      const item = items[idx];
      const unit =
        item.quantity > 0
          ? Number(item.final_line_price || item.line_price || 0) / item.quantity
          : Number(item.final_line_price || item.line_price || 0);
      item.quantity = qty;
      item.final_line_price = Math.round(unit * qty);
      item.line_price = item.final_line_price;
      item.original_line_price = item.final_line_price;
    }

    const itemCount = items.reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);

    return Object.assign({}, cart, {
      items: items,
      item_count: itemCount,
    });
  }

  function selectionImageUrl(blend) {
    const cfg = (window.OT_CART_CONFIG && window.OT_CART_CONFIG.images) || {};
    if (blend === 'women') return cfg.women || '';
    if (blend === 'couple') return cfg.couple || '';
    return cfg.men || '';
  }

  function guessBlendFromTitle(title) {
    const t = String(title || '').toLowerCase();
    if (t.indexOf('couple') !== -1) return 'couple';
    if (t.indexOf('women') !== -1 || t.indexOf('balance') !== -1) return 'women';
    return 'men';
  }

  function getPageSelection(variantId) {
    const vid = Number(variantId || OT.getSelectedVariantId() || 0);
    if (pageSelection && Number(pageSelection.variantId) === vid) return pageSelection;
    if (pageSelection && !vid) return pageSelection;

    const dom = getActivePlanFromPage();
    return {
      variantId: vid,
      productId: OT.getProductId() ? Number(OT.getProductId()) : 0,
      productTitle: dom.productTitle || 'Your order',
      variantTitle: dom.pack || '',
      priceCents: dom.priceCents || 0,
      blend: guessBlendFromTitle(dom.productTitle),
      qty: 1,
    };
  }

  function parseRupeeDisplay(text) {
    const digits = String(text || '').replace(/[^\d]/g, '');
    const rupees = Number(digits);
    return rupees > 0 ? rupees * 100 : 0;
  }

  function getActivePlanFromPage() {
    const plan =
      document.querySelector(
        '.plan-card.plan-card--active, .plan-card.pd-plan-card--active, .plan-card[aria-pressed="true"]'
      ) || document.querySelector('#ot-couple-form .plan-card.plan-card--active');
    const titleEl =
      document.getElementById('ot-display-title') ||
      document.querySelector('.product-hero h1, .product-hero__title');
    const monthEl = plan?.querySelector('.plan-card__month, .plan-card__label');
    let priceCents = plan ? Math.round(Number(plan.dataset.price) * 100) : 0;
    if (!priceCents) priceCents = parseRupeeDisplay(document.getElementById('ot-price')?.textContent);
    return {
      pack: plan?.dataset?.pack || monthEl?.textContent?.trim() || '',
      priceCents: priceCents,
      productTitle: titleEl?.textContent?.trim() || '',
    };
  }

  function isOptimisticKey(key) {
    return String(key || '').indexOf('optimistic-') === 0;
  }

  function realLineForVariant(cart, variantId) {
    if (!cart || !cart.items) return null;
    const id = Number(variantId);
    return cart.items.find(function (item) {
      if (isOptimisticKey(item.key)) return false;
      return Number(item.variant_id || item.id) === id;
    });
  }

  function isRealCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return !!cart;
    return !cart.items.some(function (item) {
      return isOptimisticKey(item.key);
    });
  }

  function buildInstantPreview(variantId, qty) {
    const sel = getPageSelection(variantId);
    const linePrice = (sel.priceCents || 0) * qty;
    const pseudoKey = 'optimistic-' + variantId;
    const item = {
      key: pseudoKey,
      id: Number(variantId),
      variant_id: Number(variantId),
      product_id: sel.productId || (OT.getProductId() ? Number(OT.getProductId()) : 0),
      quantity: qty,
      product_title: sel.productTitle || 'Your order',
      variant_title: sel.variantTitle || '',
      final_line_price: linePrice,
      line_price: linePrice,
      original_line_price: linePrice,
      image: selectionImageUrl(sel.blend),
      handle: '',
    };
    return {
      items: [item],
      item_count: qty,
      attributes: {},
      cart_level_discount_applications: [],
    };
  }

  async function setPrepaid(enabled) {
    const cfg = prepaidCfg();
    const note = enabled
      ? 'PREPAID: Customer pays Rs. 90 JazzCash advance and gets extra Rs. 90 off (voucher PREPAID90 = Rs. 180 total off). Confirm WhatsApp proof before shipping. Product balance = COD on delivery.'
      : '';
    const attributes = enabled
      ? {
          prepaid_free_delivery: 'Yes',
          prepaid_amount: cfg.amountLabel || 'Rs. 90',
          prepaid_status: 'Awaiting WhatsApp payment proof',
          prepaid_payment_method: cfg.paymentMethodName || 'JazzCash advance – extra Rs. 90 off',
        }
      : {
          prepaid_free_delivery: '',
          prepaid_amount: '',
          prepaid_status: '',
          prepaid_payment_method: '',
        };

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ note, attributes }),
    });
    await clearCartDiscountCode();
    const cart = await fetchCart();
    setCachedCart(cart);
    renderCart(cart);
  }

  function renderLineItem(item) {
    const imgUrl = lineImage(item);
    const img = imgUrl
      ? '<img src="' +
        escapeHtml(imgUrl) +
        '" alt="' +
        escapeHtml(item.product_title) +
        '" width="78" height="78" loading="eager" decoding="async" fetchpriority="high">'
      : '';
    const key = item.key;
    const decLabel = item.quantity <= 1 ? 'Remove item' : 'Decrease';
    return (
      '<div class="cart-item" data-ot-line="' +
      escapeHtml(key) +
      '">' +
      '<div class="cart-item__img">' +
      img +
      '</div>' +
      '<div class="cart-item__info">' +
      '<p class="cart-item__title">' +
      escapeHtml(item.product_title) +
      '</p>' +
      '<p class="cart-item__variant">' +
      escapeHtml(item.variant_title || '') +
      '</p>' +
      '<p class="cart-item__price">' +
      money(item.final_line_price) +
      '</p>' +
      '<div class="ot-cart-item-actions">' +
      '<div class="cart-item__qty-row ot-qty-pill" role="group" aria-label="Quantity">' +
      '<button type="button" class="ot-qty-pill__btn" data-ot-qty="' +
      escapeHtml(key) +
      '" data-ot-next="' +
      (item.quantity - 1) +
      '" aria-label="' +
      decLabel +
      '">−</button>' +
      '<span class="ot-qty-pill__val" aria-live="polite">' +
      item.quantity +
      '</span>' +
      '<button type="button" class="ot-qty-pill__btn" data-ot-qty="' +
      escapeHtml(key) +
      '" data-ot-next="' +
      (item.quantity + 1) +
      '" aria-label="Increase">+</button>' +
      '</div>' +
      '<button type="button" class="ot-remove-link" data-ot-qty="' +
      escapeHtml(key) +
      '" data-ot-next="0">Remove</button>' +
      '</div>' +
      '</div>' +
      '<button type="button" class="cart-item__remove" data-ot-qty="' +
      escapeHtml(key) +
      '" data-ot-next="0" aria-label="Remove item">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
      '</button>' +
      '</div>'
    );
  }

  function renderCart(cart, skipDiscountCleanup) {
    const body = $('#ot-cart-drawer-body');
    const footer = $('#ot-cart-drawer-footer');
    const totalEl = $('#ot-cart-total-price');
    if (!body) return;
    updateCount(cart);

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-empty"><p>Your cart is empty</p></div>';
      if (totalEl) totalEl.innerHTML = money(0);
      if (footer) {
        footer.hidden = true;
        footer.setAttribute('hidden', '');
        footer.style.display = 'none';
      }
      return;
    }

    body.innerHTML =
      '<div class="cart-items">' + cart.items.map(renderLineItem).join('') + '</div>';

    if (footer) {
      footer.hidden = false;
      footer.removeAttribute('hidden');
      footer.style.display = 'flex';
    }
    if (totalEl) totalEl.innerHTML = money(cartProductsTotal(cart));
    syncPrepaidUI(cart);

    if (!skipDiscountCleanup) scheduleDiscountCleanup(cart);
  }

  window.OT = window.OT || {};

  OT.toggleMobileMenu = function () {
    document.getElementById('mobile-nav')?.classList.toggle('mobile-nav--open');
    document.getElementById('mobile-nav-backdrop')?.classList.toggle('mobile-nav-backdrop--open');
  };

  OT.setPageSelection = function (sel) {
    if (!sel) return;
    pageSelection = {
      variantId: Number(sel.variantId) || 0,
      productId: sel.productId ? Number(sel.productId) : 0,
      productTitle: sel.productTitle || '',
      variantTitle: sel.variantTitle || '',
      priceCents: Number(sel.priceCents) || 0,
      blend: sel.blend || guessBlendFromTitle(sel.productTitle),
      qty: Number(sel.qty) || 1,
    };
  };

  OT.showCartDrawer = function () {
    const drawer = document.getElementById('ot-cart-drawer');
    const overlay = document.getElementById('ot-cart-overlay');
    if (drawer) {
      drawer.classList.add('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
    }
    if (overlay) overlay.classList.add('cart-overlay--visible');
    document.documentElement.style.overflow = 'hidden';
  };

  OT.openCart = async function (cartData) {
    OT.showCartDrawer();

    if (cartData) {
      setCachedCart(cartData);
      renderCart(cartData, true);
      return;
    }

    if (cachedCart && isRealCart(cachedCart) && cachedCart.items && cachedCart.items.length) {
      renderCart(cachedCart, true);
      refreshCartInBackground();
      return;
    }

    const body = document.getElementById('ot-cart-drawer-body');
    if (body) body.innerHTML = '<div class="cart-empty"><p>Loading cart…</p></div>';

    try {
      const cart = await fetchCart();
      setCachedCart(cart);
      renderCart(cart);
    } catch (e) {
      if (body) body.innerHTML = '<div class="cart-empty"><p>Could not load cart. Please try again.</p></div>';
    }
  };

  OT.closeCart = function () {
    const drawer = document.getElementById('ot-cart-drawer');
    const overlay = document.getElementById('ot-cart-overlay');
    if (drawer) {
      drawer.classList.remove('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (overlay) overlay.classList.remove('cart-overlay--visible');
    document.documentElement.style.overflow = '';
  };

  OT.getSelectedVariantId = function () {
    const productForm = document.getElementById('ot-product-form');
    if (productForm) return productForm.querySelector('[name="id"]')?.value || null;
    const coupleForm = document.getElementById('ot-couple-form');
    if (coupleForm) {
      return (
        coupleForm.querySelector('input[name="id"]:checked')?.value ||
        coupleForm.querySelector('input[name="id"]')?.value ||
        null
      );
    }
    return null;
  };

  OT.getSelectedQty = function () {
    return (
      document.getElementById('form-qty')?.value ||
      document.getElementById('qty-input')?.value ||
      1
    );
  };

  OT.getProductId = function () {
    return document.getElementById('ot-product-id')?.value || null;
  };

  async function clearOtherProductVariants(cart, productId, variantId) {
    if (!productId || !cart || !cart.items || !cart.items.length) return cart;
    const updates = {};
    cart.items.forEach(function (item) {
      if (
        String(item.product_id) === String(productId) &&
        Number(item.variant_id || item.id) !== Number(variantId)
      ) {
        updates[String(item.variant_id || item.id)] = 0;
      }
    });
    if (!Object.keys(updates).length) return cart;
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates }),
    });
    if (!res.ok) return cart;
    return res.json();
  };

  OT.addSelectedPackToCart = async function () {
    return OT.checkoutSelectedPack();
  };

  let checkoutInFlight = false;

  async function clearCart() {
    const res = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!res.ok) throw new Error('clear failed');
    return res.json();
  }

  OT.checkoutSelectedPack = async function () {
    const id = OT.getSelectedVariantId();
    if (!id) {
      alert('Please choose a plan first.');
      return false;
    }
    return OT.buyNow(id, OT.getSelectedQty());
  };

  OT.buyNow = async function (variantId, quantity) {
    const id = Number(variantId);
    const qty = Math.max(1, Number(quantity) || 1);
    if (!id) {
      alert('Please choose a plan first.');
      return false;
    }
    if (checkoutInFlight) return false;
    checkoutInFlight = true;

    try {
      await clearCart();
      cachedCart = null;

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id, quantity: qty }] }),
      });

      const ctype = (res.headers.get('content-type') || '').toLowerCase();
      if (res.status === 401 || res.status === 302 || res.url.indexOf('/password') !== -1) {
        alert('Store is password-protected. Unlock Online Store → Preferences, then try again.');
        return false;
      }

      if (!res.ok) {
        let msg = 'Could not start checkout.';
        if (ctype.indexOf('json') !== -1) {
          try {
            const err = await res.json();
            msg = err.description || err.message || msg;
          } catch (e) {}
        }
        alert(msg);
        return false;
      }

      setTimeout(function () {
        try {
          if (typeof fbq === 'function') {
            fbq('track', 'InitiateCheckout', {
              content_ids: [String(id)],
              content_type: 'product',
              value: qty * 1185,
              currency: 'PKR',
              num_items: qty,
            });
          }
        } catch (e) {}
      }, 0);

      window.location.href = '/checkout';
      return true;
    } catch (e) {
      alert('Network error. Please try again.');
      return false;
    } finally {
      checkoutInFlight = false;
    }
  };

  OT.cartQty = async function (keyOrId, qty) {
    if (isOptimisticKey(keyOrId)) return;
    const nextQty = Math.max(0, Number(qty) || 0);
    const requestVersion = ++qtyRequestVersion;

    if (cachedCart) {
      const optimistic = optimisticQtyChange(cachedCart, keyOrId, nextQty);
      if (optimistic) {
        setCachedCart(optimistic);
        renderCart(optimistic, true);
      }
    }

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: keyOrId, quantity: nextQty }),
      });
      if (!res.ok) throw new Error('change failed');
      const cart = await res.json();
      if (requestVersion !== qtyRequestVersion) return;
      setCachedCart(cart);
      renderCart(cart, true);
    } catch (e) {
      if (requestVersion !== qtyRequestVersion) return;
      try {
        const cart = await fetchCart();
        setCachedCart(cart);
        renderCart(cart);
      } catch (err) {}
    }
  };

  let addInFlight = false;

  OT.addToCart = async function (variantId, quantity, openDrawer) {
    const id = Number(variantId);
    const qty = Math.max(1, Number(quantity) || 1);
    if (!id) {
      alert('Please choose a plan first.');
      return false;
    }
    if (addInFlight) return false;
    addInFlight = true;

    try {
      if (openDrawer !== false) {
        OT.showCartDrawer();
        renderCart(buildInstantPreview(id, qty), true);
      }

      let serverCart;
      try {
        serverCart = await fetchCart();
      } catch (e) {
        if (openDrawer !== false) OT.closeCart();
        alert('Network error adding to cart. Please try again.');
        return false;
      }

      if (realLineForVariant(serverCart, id)) {
        setCachedCart(serverCart);
        if (openDrawer !== false) renderCart(serverCart, true);
        else updateCount(serverCart);
        return true;
      }

      const productId = OT.getProductId();
      if (productId) {
        serverCart = await clearOtherProductVariants(serverCart, productId, id);
      }

      let res;
      try {
        res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id, quantity: qty }] }),
        });
      } catch (e) {
        if (openDrawer !== false) OT.closeCart();
        alert('Network error adding to cart. Please try again.');
        return false;
      }

      const ctype = (res.headers.get('content-type') || '').toLowerCase();
      if (res.status === 401 || res.status === 302 || res.url.indexOf('/password') !== -1) {
        if (openDrawer !== false) OT.closeCart();
        alert('Store is password-protected. Unlock Online Store → Preferences, then try again.');
        return false;
      }

      if (!res.ok) {
        let msg = 'Could not start checkout.';
        if (ctype.indexOf('json') !== -1) {
          try {
            const err = await res.json();
            msg = err.description || err.message || msg;
          } catch (e) {}
        }
        if (openDrawer !== false) OT.closeCart();
        alert(msg);
        return false;
      }

      try {
        serverCart = await fetchCart();
        setCachedCart(serverCart);
      } catch (e) {
        if (openDrawer !== false) OT.closeCart();
        alert('Added to cart but could not refresh. Please try again.');
        return false;
      }

      if (openDrawer !== false) renderCart(serverCart, true);
      else updateCount(serverCart);

      setTimeout(function () {
        try {
          if (typeof fbq === 'function') {
            fbq('track', 'AddToCart', {
              content_ids: [String(id)],
              content_type: 'product',
              value: qty * 1185,
              currency: 'PKR',
            });
          }
        } catch (e) {}
      }, 0);

      return true;
    } finally {
      addInFlight = false;
    }
  };

  async function handleProductSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.dataset.otSubmitting === '1') return;
    form.dataset.otSubmitting = '1';

    const id = form.querySelector('[name="id"]')?.value;
    const qty = OT.getSelectedQty();
    const btn = document.getElementById('atc-btn') || form.querySelector('[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.dataset.otBusy = '1';
      btn.textContent = 'Processing...';
    }
    let redirected = false;
    try {
      redirected = await OT.buyNow(id, qty);
    } finally {
      form.dataset.otSubmitting = '';
      if (!redirected && btn) {
        btn.disabled = false;
        btn.dataset.otBusy = '';
        if (typeof OT.syncAtcLabel === 'function') OT.syncAtcLabel();
        else btn.textContent = btn.getAttribute('data-label-desktop') || 'Order now - Free Delivery 🚚';
      }
    }
  }

  function bindCartActions() {
    const drawer = document.getElementById('ot-cart-drawer');
    if (!drawer || drawer.dataset.otActionsBound === '1') return;
    drawer.dataset.otActionsBound = '1';
    drawer.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-ot-qty]');
      if (!btn) return;
      e.preventDefault();
      OT.cartQty(btn.getAttribute('data-ot-qty'), btn.getAttribute('data-ot-next'));
    });
  }

  function bindForms() {
    bindCartActions();

    const form = document.getElementById('ot-product-form');
    if (form && !form.dataset.otBound) {
      form.dataset.otBound = '1';
      form.addEventListener('submit', handleProductSubmit);
    }

    const coupleForm = document.getElementById('ot-couple-form');
    if (coupleForm && !coupleForm.dataset.otBound) {
      coupleForm.dataset.otBound = '1';
      coupleForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (coupleForm.dataset.otSubmitting === '1') return;
        coupleForm.dataset.otSubmitting = '1';
        const id =
          coupleForm.querySelector('input[name="id"]:checked')?.value ||
          coupleForm.querySelector('input[name="id"]')?.value;
        const btn = coupleForm.querySelector('.js-couple-atc');
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Processing...';
        }
        let redirected = false;
        try {
          redirected = await OT.buyNow(id, 1);
        } finally {
          coupleForm.dataset.otSubmitting = '';
          if (!redirected && btn) {
            btn.disabled = false;
            if (typeof OT.syncCoupleAtcLabel === 'function') OT.syncCoupleAtcLabel();
            else btn.textContent = btn.getAttribute('data-label-desktop') || 'Order now - Free Delivery 🚚';
          }
        }
      });
    }

    document.querySelectorAll('.cart-toggle-btn, [data-ot-open-cart]').forEach((el) => {
      if (el.dataset.otBound) return;
      el.dataset.otBound = '1';
      el.addEventListener('click', (e) => {
        e.preventDefault();
        OT.openCart();
      });
    });

    const prepaidCheck = document.getElementById('ot-prepaid-check');
    if (prepaidCheck && !prepaidCheck.dataset.otBound) {
      prepaidCheck.dataset.otBound = '1';
      prepaidCheck.addEventListener('change', function () {
        setPrepaid(!!prepaidCheck.checked);
      });
    }

    prefetchCart();
  }

  OT.resetOrderFlowState = function () {
    checkoutInFlight = false;

    const productForm = document.getElementById('ot-product-form');
    if (productForm) productForm.dataset.otSubmitting = '';

    const coupleForm = document.getElementById('ot-couple-form');
    if (coupleForm) coupleForm.dataset.otSubmitting = '';

    const atcBtn = document.getElementById('atc-btn');
    if (atcBtn) {
      atcBtn.disabled = false;
      atcBtn.dataset.otBusy = '';
      if (typeof OT.syncAtcLabel === 'function') OT.syncAtcLabel();
      else {
        const mobile = window.matchMedia('(max-width: 767px)').matches;
        atcBtn.textContent = mobile
          ? atcBtn.getAttribute('data-label-mobile') || 'Order now - Free Delivery 🚚'
          : atcBtn.getAttribute('data-label-desktop') || 'Order now - Free Delivery 🚚';
      }
    }

    document.querySelectorAll('.js-couple-atc').forEach(function (btn) {
      btn.disabled = false;
      btn.dataset.otBusy = '';
      if (typeof OT.syncCoupleAtcLabel === 'function') OT.syncCoupleAtcLabel();
      else btn.textContent = btn.getAttribute('data-label-desktop') || 'Order now - Free Delivery 🚚';
    });

    const stickyBtn = document.getElementById('ot-sticky-order-btn');
    if (stickyBtn) {
      stickyBtn.disabled = false;
      stickyBtn.dataset.otBusy = '';
      if (typeof OT.syncStickyLabel === 'function') OT.syncStickyLabel();
      else stickyBtn.textContent = stickyBtn.getAttribute('data-label') || 'Order now - Free Delivery 🚚';
    }
  };

  window.addEventListener('pageshow', function () {
    OT.resetOrderFlowState();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') OT.resetOrderFlowState();
  });

  OT._cartReady = true;
  if (typeof OT._onCartReady === 'function') OT._onCartReady();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindForms);
  } else {
    bindForms();
  }

  window.addEventListener('resize', function () {
    const drawer = document.getElementById('ot-cart-drawer');
    if (drawer && !drawer.classList.contains('cart-drawer--open')) {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  });
})();
